import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19.972} height={20} {...props}>
    <defs>
      <linearGradient
        id="a"
        x1={0.313}
        y1={0.022}
        x2={0.676}
        y2={0.952}
        gradientUnits="objectBoundingBox">
        <stop offset={0.01} stopColor="#ffed0d" />
        <stop offset={0.29} stopColor="#fef000" />
        <stop offset={0.83} stopColor="#fef000" stopOpacity={0} />
      </linearGradient>
    </defs>
    <g data-name="Quiz1 20">
      <g data-name="Layer 1">
        <path
          data-name="Path 7751"
          d="M14.683 10.823a5.748 5.748 0 0 0-1.705 3.238H7.005c-.042-.2-.077-.406-.127-.605a5.067 5.067 0 0 0-1.413-2.427A6.308 6.308 0 0 1 3.61 7.355a6.438 6.438 0 0 1 12.507-2.869 6.165 6.165 0 0 1-1.434 6.337Z"
          fill="#ffe000"
        />
        <path
          data-name="Path 5769"
          d="M7.088 15.247h5.863a19.748 19.748 0 0 1-.135 2.492 2.907 2.907 0 0 1-5.715-.243 21.964 21.964 0 0 1-.014-2.25Z"
          fill="#ffc800"
        />
        <path
          data-name="Path 7752"
          d="M12.931 16.076a10.527 10.527 0 0 1-.114 1.664 2.857 2.857 0 0 1-3.006 2.257 2.888 2.888 0 0 1-1.628-.61 13.245 13.245 0 0 0 4.748-3.311Z"
          fill="#efb600"
        />
        <path
          data-name="Path 5770"
          d="m1.943 3.888-.917-.916a.535.535 0 0 1 0-.758l.026-.026a.536.536 0 0 1 .757 0l.917.915a.536.536 0 0 1 0 .758l-.026.026a.535.535 0 0 1-.757.001Z"
          fill="#ffe000"
        />
        <path
          data-name="Path 5771"
          d="m17.243 3.893-.009-.009a.536.536 0 0 1 0-.758l.923-.922a.536.536 0 0 1 .758 0l.012.012a.535.535 0 0 1 0 .757L18 3.892a.536.536 0 0 1-.757 0Z"
          fill="#ffe000"
        />
        <path
          data-name="Path 5772"
          d="m2.743 9.79-.91.909a.535.535 0 0 1-.758 0l-.021-.021a.536.536 0 0 1 0-.758l.91-.909a.537.537 0 0 1 .759 0l.021.021a.536.536 0 0 1-.001.758Z"
          fill="#ffe000"
        />
        <path
          data-name="Path 5773"
          d="m17.222 9.026.009-.009a.536.536 0 0 1 .758 0l.918.919a.535.535 0 0 1 0 .758l-.008.008a.535.535 0 0 1-.758 0l-.919-.918a.537.537 0 0 1 0-.759Z"
          fill="#ffe000"
        />
        <rect
          data-name="Rectangle 977"
          width={2.357}
          height={1.155}
          rx={0.577}
          transform="translate(0 5.875)"
          fill="#ffe000"
        />
        <path
          data-name="Path 5774"
          d="M19.972 7.028a.645.645 0 0 1-.081.01H18.15a.537.537 0 0 1-.537-.536v-.086a.536.536 0 0 1 .536-.536h1.286a.537.537 0 0 1 .537.536v.612Z"
          fill="#ffe000"
        />
        <circle
          data-name="Ellipse 223"
          cx={4.756}
          cy={4.756}
          r={4.756}
          transform="translate(4.541 .912)"
          fill="url(#a)"
        />
        <path
          data-name="Path 7753"
          d="M9.423 9.789h1.147v1.147H9.423Zm2.088-4.991a1.733 1.733 0 0 0-2.109-.763 1.863 1.863 0 0 0-1.141 2.217H9.41c0-.21-.008-.4 0-.6a.584.584 0 1 1 .9.528 2.5 2.5 0 0 0-.881 2.424h1.13a.221.221 0 0 0 .02-.05 2.571 2.571 0 0 0 0-.273 1.4 1.4 0 0 1 .569-1.289 1.712 1.712 0 0 0 .363-2.195Z"
          fill="#ef0f01"
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;
